import { useMutation } from '@tanstack/react-query';
import { initAggregateInfra } from '../services';
import { useSelector } from 'react-redux';
import { selectAuthToken } from 'selectors';
import { AxiosResponse } from 'axios';
import {
  AggregateInfraErrorResponse,
  AggregateInfraParams,
  AggregateInfraSuccessResponse,
} from 'SandboxModule/types';
import { useNotification } from 'hooks/useNotification';

export const useInitAggregateInfra = () => {
  const token = useSelector(selectAuthToken);
  const { showSuccess, showError } = useNotification();

  const mutation = useMutation<
    AxiosResponse<AggregateInfraSuccessResponse>,
    AxiosResponse<AggregateInfraErrorResponse>,
    AggregateInfraParams
  >({
    mutationFn: async (data) => {
      if (!token) {
        throw new Error('No auth token available');
      }
      return initAggregateInfra(data, token);
    },
    onSuccess: (response) => {
      if (response.data?.message) {
        showError(`Init Aggregate Infra failed! ${response.data?.message}`);
      } else {
        showSuccess('Successfully initiated Aggregate Infra!');
      }
    },
    onError: (error) => {
      showError(`Init Aggregate Infra failed! ${error.data?.message}`);
    },
  });

  return {
    initAggregateInfra: mutation.mutate,
  };
};
